module.exports = __webpack_public_path__ + "img/site_type_img_15.6010acb0.png";